<template>
  <div class="productfeature flex-box">
    <div class="productfeature-title">{{ title }}</div>
    <div class="productfeature-description">{{ description }}</div>
    <div class="tab-container">
      <mobile-tab-fold :tabs="tabList" :value="activeName" @input="onFoldTab" />
      <el-tabs v-model="activeName" @tab-click="tabsChange">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in tabList" :key="k">
          
            <div class="content-wrap">
              <div class="right-bj"></div>
              <transition name="fade-transform1" mode="out-in">
                <div class="content-left" v-show="activeName === item.name">
                  <div class="qipao1"></div>
                  <div class="qipao2"></div>
                    <div class="cl-title">
                      {{ item.title }}<template v-if="item.otherTitle"><br/>{{ item.otherTitle }}</template>
                    </div>
                    <div class="cl-description" v-if="item.description">{{ item.description }}</div>
                    <div class="cl-list">
                      <div class="cl-list-item" :class="{ 'cl-list-item2': !subItem.title, 'cl-list-item3': subItem.content1 }" v-for="(subItem, sk) in item.contentList" :key="sk">
                        <div class="cl-l-i-title" v-if="subItem.title">{{ subItem.title }}：</div>
                        <div class="cl-l-i-content" v-if="subItem.content">{{ subItem.content }}</div>
                        <div class="cl-l-i-content1" v-if="subItem.content1"><span v-if="subItem.title1">{{ subItem.title1 }}:</span> {{ subItem.content1 }}</div>
                      </div>
                    </div>
                </div>
              </transition>
              <div class="content-right">
                <transition name="fade-transform2" mode="out-in">
                  <el-image
                    class="preview-shot"
                    fit="contain"
                    :src="item.effectDrawing"
                    :preview-src-list="previewImgs"
                    v-show="activeName === item.name"
                  />
                </transition>
              </div>
            </div>
            
        </el-tab-pane>
      </el-tabs>
    </div>
    
  </div>
</template>

<script>
import MobileTabFold from '@/components/MobileTabFold/index.vue'
export default {
  components: { MobileTabFold },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      activeName: 'first',
      activeIndexOne: 0,
      timeoutOne: null,
    }
  },
  computed: {
    previewImgs() {
      return this.tabList.map(item => item.effectDrawing).filter(Boolean)
    }
  },
  watch: {
    activeName: {
      handler(n) {
      }
    }
  },
  mounted() {
    // this.timeoutModuleOne();
  },
  destroyed() {
    // this.clearTimeoutOne();
  },
  methods: {
    timeoutModuleOne() {
      this.timeoutOne = setInterval(() => {
        if (this.activeIndexOne === this.tabList.length -1) {
          this.activeIndexOne = 0;
        } else {
          this.activeIndexOne++;
        }
        this.activeName = this.tabList[this.activeIndexOne].name
      }, 5000)
    },
    clearTimeoutOne() {
      clearInterval(this.timeoutOne)
    },
    tabsChange(val) {
      this.activeIndexOne = Number(val.index);
    },
    onFoldTab(name) {
      this.activeName = name
      const idx = this.tabList.findIndex(item => item.name === name)
      if (idx >= 0) this.activeIndexOne = idx
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";


.fade-transform1-enter-active,
.fade-transform2-enter-active {
  transition: all 2s;
}

.fade-transform1-enter {
  opacity: 0;
  transform: translateX(-50px);
}
.fade-transform2-enter {
  opacity: 0;
  transform: translateX(50px);
}

.productfeature {
  flex-direction: column;
  align-items: center;

  .productfeature-title {
    font-size: 4rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333;
    line-height: 4rem;
    padding: 9rem 0 2.4rem;
  }

  .productfeature-description {
    font-size: 1.8rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    padding-bottom: 7.6rem;
  }

  .tab-container {
    width: 100%;
    display: flex;
    justify-content: center;

    ::v-deep .el-tabs {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .el-tabs__nav-wrap::after {
        display: none;
      }
      .el-tabs__header {
        width: calc(192rem - 52rem);
        margin: 0;

        .el-tabs__nav {
          width: 100%;

          .el-tabs__item {
            width: 24rem;
            height: 4.6rem;
            display: inline-flex;
            justify-content: center;
            font-size: 2rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 2rem;
            box-shadow: none;
          }

          .el-tabs__active-bar {
            height: 0.2rem;
            width: 33%;
            background-color: #FB0000;
          }

          .el-tabs__item.is-active, .el-tabs__item:hover {
            color: #FB0000;
          }
        }
      }
      .el-tabs__content {
        width: 100%;
        // border-top: 0.2rem solid #D8E9FE;
      }
    }

  }
  .content-wrap {
    position: relative;
    height: 78rem;
    width: 100%;
    background: linear-gradient(90deg, #fbfdff 0%, #eef6ff 100%);
    .right-bj {
      position: absolute;
      width: 37rem;
      height: 78rem;
      background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
      opacity: 0.8;
      top: 0;
      right: 0;
    }
    
    .content-left {
      position: absolute;
      width: 57.4rem;
      height: 50.6rem;
      left: 24.6rem;
      top: 11rem;
      padding: 4.1rem 0 0 3.4rem;
      .qipao1 {
        position: absolute;
        width: 7rem;
        height: 7rem;
        background: linear-gradient(161deg, #A1D1FF 0%, #72BCFB 36%, #1F96F3 100%);
        opacity: 0.16;
        top: 2.5rem;
        left: 0;
        border-radius: 50%;
      }
      .qipao2 {
        width: 3.4rem;
        height: 3.4rem;
        background: #3674FE;
        border-radius: 50%;
        opacity: 0.04;
        position: absolute;
        top: 0;
        left: 7.9rem;
      }
      .cl-title {
        font-size: 3.6rem;
        font-weight: 600;
        color: #333333;
        line-height: 5.4rem;
      }
      .cl-description {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 2.4rem;
        color: #333333;
        line-height: 3.4rem;
        text-align: left;
        font-style: normal;
        margin-top: 2.1rem;
      }
      .cl-list {
        margin-top: 4.1rem;
        .cl-list-item {
          margin-bottom: 3.6rem;
          .cl-l-i-title {
            height: 2rem;
            font-size: 2rem;
            font-weight: 600;
            color: #333333;
            line-height: 2rem;
            margin-bottom: 1.6rem;
          }
          .cl-l-i-content {
            font-size: 1.6rem;
            font-weight: 400;
            color: #333333;
            line-height: 1.6rem;
          }

          .cl-l-i-content1 {
            font-size: 1.6rem;
            line-height: 2.4rem;
            text-align: left;
            font-style: normal;
            color: #666A77;
            position: relative;
            padding-left: 2.1rem;
            span {
              color: #3674FE;
              font-weight: 600;
            }
            &::before {
              position: absolute;
              left: 0;
              top: .5rem;
              content: '';
              width: 1rem;
              height: 1rem;
              border: 0.2rem solid #3674FE;
              display: inline-block;
              border-radius: 50%;
              margin-right: 1.2rem;
            }
          }

        }
        .cl-list-item2 {
          margin-bottom: 3.2rem;
          .cl-l-i-content {
            font-size: 2rem;
            line-height: 3.2rem;
            padding-left: 3rem;
            position: relative;
            &::before {
              position: absolute;
              left: 0;
              top: .9rem;
              content: '';
              width: 1rem;
              height: 1rem;
              border: 0.2rem solid #3674FE;
              display: inline-block;
              border-radius: 50%;
              margin-right: 1.2rem;
            }
          }
        }

        .cl-list-item3 {
          margin-bottom: 2.4rem;
        }
        
      }
    }
    .content-right {
      position: absolute;
      width: 105.3rem;
      height: 48.7rem;
      right: -5rem;
      top: 12.7rem;
      ::v-deep .preview-shot {
        width: 100%;
        height: 100%;
        cursor: zoom-in;
        .el-image__inner {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }

  
}

@import "@/styles/mixins.scss";

@include mobile {
  .productfeature {
    .productfeature-title {
      width: 100%;
      font-size: 2.4rem !important;
      line-height: 3.2rem !important;
      padding: 4.8rem 1.6rem 1.6rem;
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }
    .productfeature-description {
      width: 100%;
      font-size: 1.4rem !important;
      line-height: 2.2rem !important;
      padding: 0 1.6rem 3.2rem;
      text-align: center;
      white-space: normal;
      word-break: break-word;
    }
    ::v-deep .el-tabs__header {
      display: none !important;
    }
    .content-wrap {
      height: auto;
      .right-bj {
        display: none;
      }
      .content-left,
      .content-right {
        position: relative !important;
        width: 100% !important;
        height: auto !important;
        left: auto !important;
        right: auto !important;
        top: auto !important;
        padding: 2.4rem 1.6rem !important;
      }
      .content-right ::v-deep .preview-shot,
      .content-right ::v-deep .preview-shot .el-image__inner {
        width: 100%;
        height: auto;
      }
      .content-left .cl-title {
        font-size: 2.2rem;
        line-height: 3rem;
        height: auto;
        white-space: normal;
        word-break: break-word;
      }
      .content-left .cl-list-item,
      .content-left .cl-l-i-content,
      .content-left .cl-l-i-title {
        height: auto;
        overflow: visible;
        white-space: normal;
        word-break: break-word;
      }
    }
  }
}
</style>
